import { css } from 'styled-components';

import type { ColorSchemeMode } from '../../types/color-scheme';
import type { Theme } from '../../types/theme';
import type { TokenColorMode } from '../../types/token-modes';

export const colorSchemeModes: ColorSchemeMode[] = ['light', 'dark'];

// TODO (legacied consistent-return)
// This failure is legacied in and should be updated. DO NOT COPY.
/* eslint-disable consistent-return */
export function cssForDarkMode(content: string | ReturnType<typeof css>) {
  return ({ theme: { tokenColorMode } }: { theme: Theme }) => {
    if (tokenColorMode === 'auto') {
      return css`
        @media (prefers-color-scheme: dark) {
          ${content}
        }
      `;
    }

    if (tokenColorMode === 'dark') {
      return css`
        ${content}
      `;
    }

    return;
  };
}
/* eslint-enable consistent-return */

// TODO (legacied consistent-return)
// This failure is legacied in and should be updated. DO NOT COPY.
/* eslint-disable consistent-return */
export function cssForLightMode(content: string | ReturnType<typeof css>) {
  return ({ theme: { tokenColorMode } }: { theme: Theme }) => {
    if (tokenColorMode === 'auto') {
      return css`
        @media (prefers-color-scheme: light) {
          ${content}
        }
      `;
    }

    if (tokenColorMode === 'light') {
      return css`
        ${content}
      `;
    }

    return;
  };
}
/* eslint-enable consistent-return */

/**
 * generates css for a given tokenColorMode based on the current theme
 */
export function cssForTokenColorMode({
  tokenColorMode,
  light,
  dark,
}: {
  tokenColorMode: TokenColorMode;
  light: string | ReturnType<typeof css>;
  dark?: string | ReturnType<typeof css>;
}) {
  if (tokenColorMode === 'light' || dark === undefined) {
    return css`
      ${light}
    `;
  }

  if (tokenColorMode === 'dark') {
    return css`
      ${dark}
    `;
  }

  return css`
    ${light}

    @media (prefers-color-scheme: dark) {
      ${dark}
    }
  `;
}

/**
 * generates css which will automatically switch between light and dark mode
 */
export function cssForColorScheme({
  light,
  dark,
}: {
  light: string | ReturnType<typeof css>;
  dark?: string | ReturnType<typeof css>;
}) {
  return css`
    ${({ theme: { tokenColorMode } }: { theme: Theme }) =>
      cssForTokenColorMode({
        tokenColorMode,
        light,
        dark,
      })};
  `;
}
